//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadSafeImg from "@/components/upload-safeimg.vue";
import lodash from 'lodash';
export default {
    props: ["value", "label"],
    data() {
        return {
            uploading: false,
            imgData: {
                ...this.value
            }
        };
    },
    computed: {
        isNotUpload() {
            if (!this.imgData) return true;
            return !this.imgData.thumb_key;
        }
    },
    methods: {
        handleUploadSuccess(resp) {
            this.imgData.thumb_url = resp.url;
            this.imgData.thumb_key = resp.key;
        },
    },
    mounted() {
    },
    filters: {},
    components: {UploadSafeImg},
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (newVal && lodash.isObject(newVal)) {
                    if (oldVal && newVal.thumb_key == oldVal.thumb_key) return;
                    this.imgData = {
                        ...newVal,
                    }
                } else {
                    this.imgData = {
                        thumb_url: '',
                        thumb_key: '',
                    }
                }
            },
            deep: true,
        },
        imgData: {
            handler(newVal) {
                if (newVal.thumb_key) {
                    this.$emit('input', newVal);
                }
            },
            deep: true,
        }
    }
}
